import {Injectable} from '@angular/core';
import {CrudService} from './crud.service';
import {Spring} from '../constants/spring';

@Injectable({
  providedIn: 'root'
})
export class UpcontroService {

  constructor(private crud: CrudService,
              private spring: Spring) {
  }

  getPermisosUsuario(idusuari: number) {
    return this.crud.get(`${this.spring.GET_PERMISOS_USUARIO}${idusuari}`);
  }

  getPermisoControlUsuario(control: number, idusuari: number) {
    return this.crud.get(`${this.spring.UPPERMIS_GET_PERMISO_CONTROL_USUARIO}${control}/${idusuari}`);
  }
}
